import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// We need to extend the default tailwind-merge configuration to register our custom classes.
// This prevents conflicts when tailwind-merge tries to resolve classes with the same utility function.
// For example, without registering 'text-24' and 'text-base-black', tailwind-merge might incorrectly
// assume they compete with Tailwind's default text-{size} utilities and remove one of them.
// https://github.com/dcastil/tailwind-merge/blob/main/docs/configuration.md#usage-with-custom-tailwind-config
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": ["text-24", "text-10"],
      "text-color": ["text-base-black"],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
